import { Component, Input, OnInit } from '@angular/core';

import range from 'lodash-es/range';

@Component({
  selector: 'app-progress-steps',
  templateUrl: `./progress-steps.component.html`,
})
export class ProgressStepsComponent implements OnInit {
  @Input() numberOfSteps: number;
  @Input() currentStep: number;
  steps: number[];

  ngOnInit() {
    this.steps = range(this.numberOfSteps);
  }
}
